{
  "name": "@dub/analytics",
  "version": "0.0.15",
  "description": "",
  "keywords": [
    "analytics",
    "dub"
  ],
  "repository": {
    "url": "github:dubinc/analytics",
    "directory": "packages/web"
  },
  "license": "MPL-2.0",
  "type": "module",
  "exports": {
    "./package.json": "./package.json",
    ".": {
      "browser": "./dist/index.js",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./react": {
      "browser": "./dist/react/index.js",
      "import": "./dist/react/index.js",
      "require": "./dist/react/index.cjs"
    }
  },
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "typesVersions": {
    "*": {
      "*": [
        "dist/index.d.ts"
      ],
      "react": [
        "dist/react/index.d.ts"
      ]
    }
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "eslint .",
    "lint-fix": "eslint . --fix",
    "type-check": "tsc --noEmit"
  },
  "eslintConfig": {
    "extends": [
      "@dub/eslint-config"
    ],
    "rules": {
      "tsdoc/syntax": "off"
    }
  },
  "dependencies": {
    "server-only": "^0.0.1"
  },
  "devDependencies": {
    "@dub/eslint-config": "workspace:0.0.0",
    "@swc/core": "^1.3.66",
    "@types/node": "^20.3.1",
    "@types/react": "^18.2.14",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "tsup": "7.1.0"
  }
}